import { listKeys } from '@portals-platform/api-client';
import type { CertificateSearchParams } from './models.js';

export const queryKeys = {
  captivePolicies: () => [...listKeys.all('captive-policies'), 'for-certificates'] as const,
  certificate: (id: string) => listKeys.detail('certificates', id),
  certificates: () => listKeys.all('certificates'),
  certificateSearch: (params: CertificateSearchParams) =>
    [...listKeys.all('certificates'), 'search', params] as const,
  certificateTemplatesByCountry: (countryCode: string) =>
    [...listKeys.all('certificate-templates'), 'country', countryCode] as const,
  countries: () => listKeys.all('countries'),
  countryAssureds: () => listKeys.all('country-assureds'),
  currentUser: () => listKeys.all('current-user'),
  locationLimits: (policyYear: string, countryCode: string) =>
    [...listKeys.all('location-limits'), policyYear, countryCode] as const,
};
